/* 生年月日ログイン(申込人) */
import React, { useState, useEffect } from 'react';
import Block from '../molecules/Block';
import Annotation from '../atoms/Annotation';
import axios from '../axios';
import RowDate from '../molecules/RowDate';
import { Row, Col } from 'react-bootstrap';
import Moment from 'moment';
import { handleBrowzerBack } from '../BrowzerBack';
import LoadingModal from '../molecules/LoadingModal';
import { Button } from 'react-bootstrap';
import { createRoot } from 'react-dom/client';

// 生年月日をPOSTするときのフォーマット
const momentFormat = 'YYYY-MM-DD';

const BirthLogin: React.FC = () => {
  // 処理結果通知ダイアログ
  const [birthday_login_error_message, setBirthDayMessage] = useState();
  const [birthday, setBirthDay] = useState(Moment().subtract(30, 'years').format(momentFormat));
  // ローディング画面表示状態
  const [is_loading, setIsLoading] = useState(false);

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowzerBack();
  }, []);
  const handleChangeInput = (changed_value: string | Date) => {
    let setParam = '';
    if (
      // Date型
      Object.prototype.toString.call(changed_value).slice(8, -1).toLowerCase() === 'date'
    ) {
      setParam = Moment(changed_value).format(momentFormat);
    } else if (
      Object.prototype.toString.call(changed_value).slice(8, -1).toLowerCase() === 'null'
    ) {
      // null
      setParam = '';
    } else if (typeof changed_value === 'string') {
      // string型
      setParam = changed_value;
    }
    setBirthDay(setParam);
  };

  /**
   * ログイン
   */
  const handleBirthLoginClick = () => {
    const login = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get('mypage/login/birthday_login', {
          params: {
            birthday: birthday,
          },
        });
        // ログインOK
        // 受付CDと受付IDを取得
        const r_cd = response.data.reception_cd;
        const r_id = response.data.reception_id;
        // 案件詳細画面へ遷移
        // TODO sakuma 受付cd, idをURIに持たせるよう修正する
        location.replace(`${process.env.MIX_MOCK_URL}/reception/${r_cd}/${r_id}`);
      } catch (error) {
        // ログインNG
        console.error(error);
        setBirthDayMessage(error.response.data.message);
      } finally {
        setIsLoading(false);
      }
    };
    login();
  };
  return (
    <>
      <div className="mt-3 mt-sm-5 birth-login-top">
        <div className="col-11 col-sm-11 col-md-8 mx-auto">
          <p>
            <b>
              愛媛銀行のローンをお申込みいただきましてありがとうございます。
              <br />
              お申込みいただきましたローンの審査結果を回答いたします。
            </b>
          </p>
        </div>
      </div>
      <Block
        label="本人確認"
        content={
          <>
            {/* 生年月日入力欄 */}
            <Annotation text="ご本人さまの確認として、生年月日（西暦）を入力してください。" />
            <div className="mt-3"></div>
            <div>
              <RowDate
                id="birthday"
                value={
                  birthday !== null && birthday !== ''
                    ? new Date(Moment(birthday).format('YYYY/MM/DD'))
                    : null
                }
                // value={new Date(birthday)}
                label="生年月日"
                need={true}
                disabled={false}
                handleChange={(date: Date) => {
                  handleChangeInput(date);
                }}
              />
            </div>
            {typeof birthday_login_error_message !== 'undefined' && (
              // ログインエラー有
              <Row className="d-flex align-items-center justify-content-center">
                <Col></Col>
                <Col md={9} className="alert-danger alert-danger-custom">
                  {birthday_login_error_message}
                </Col>
              </Row>
            )}
            <div className="mt-5"></div>
            <div className="text-center">
              <Button size="lg" onClick={handleBirthLoginClick} variant="main-color">
                審査結果に進む
              </Button>
            </div>
            <LoadingModal show={is_loading} />
          </>
        }
      />
    </>
  );
};

const container = document.getElementById('application-person-birth-login');
if (container) {
  const root = createRoot(container);
  root.render(<BirthLogin />);
}
